"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _accessibility = require("../../constants/accessibility");
var _StyledMenuItem = _interopRequireDefault(require("./components/StyledMenuItem"));
var _excluded = ["changeMenuFocus", "children", "className", "currentFocused", "dataMetrics", "disabled", "enableAutoFocus", "index", "isNestedMenu", "leftIcon", "onClick", "parentId", "remove", "rightIcon", "setSubMenuState", "selected", "subNav", "shortCutKey", "variant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultProps = {
  dataMetrics: {
    root: 'fuse_menu_item'
  },
  variant: 'standard'
};
var MenuItem = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var changeMenuFocus = props.changeMenuFocus,
    children = props.children,
    className = props.className,
    currentFocused = props.currentFocused,
    dataMetrics = props.dataMetrics,
    disabled = props.disabled,
    enableAutoFocus = props.enableAutoFocus,
    index = props.index,
    isNestedMenu = props.isNestedMenu,
    leftIcon = props.leftIcon,
    onClick = props.onClick,
    parentId = props.parentId,
    remove = props.remove,
    rightIcon = props.rightIcon,
    setSubMenuState = props.setSubMenuState,
    selected = props.selected,
    subNav = props.subNav,
    shortCutKey = props.shortCutKey,
    variant = props.variant,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    subNavAnchor = _useState2[0],
    setSubNavAnchor = _useState2[1];
  var subNavItemRef = (0, _react.useRef)(null);
  var handleMenuClose = function handleMenuClose() {
    setSubNavAnchor(null);
  };
  var handleMenuOpen = function handleMenuOpen(event) {
    setSubNavAnchor(event.currentTarget);
  };

  // ACCESSIBILITY
  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (enableAutoFocus) {
      switch (event.key) {
        case _accessibility.KEY_DOWN_MAP.ARROW_RIGHT:
          {
            if (subNav) {
              handleMenuOpen(event);
              setSubMenuState(true);
            }
            break;
          }
        case _accessibility.KEY_DOWN_MAP.ARROW_LEFT:
          {
            if (subNav) {
              handleMenuClose();
              setSubMenuState(false);
            }
            break;
          }
        case _accessibility.KEY_DOWN_MAP.ARROW_UP:
          {
            changeMenuFocus(index - 1, _accessibility.KEY_DOWN_MAP.ARROW_UP); // prev item
            event.preventDefault();
            event.stopPropagation();
            break;
          }
        case _accessibility.KEY_DOWN_MAP.ARROW_DOWN:
          {
            changeMenuFocus(index + 1); // next item
            event.preventDefault();
            event.stopPropagation();
            break;
          }
        case _accessibility.KEY_DOWN_MAP.TAB:
          {
            event.preventDefault();
            break;
          }
        default:
          {
            break;
          }
      }
    }
  };
  var isFocused = currentFocused === index && enableAutoFocus;
  if (isFocused) {
    if (subNavItemRef.current) {
      subNavItemRef.current.focus();
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_StyledMenuItem["default"], (0, _extends2["default"])({
    className: className,
    dataMetrics: {
      root: mergedDataMetrics.root
    },
    disabled: disabled,
    enableAutoFocus: enableAutoFocus,
    handleOnKeyDown: handleOnKeyDown,
    handleMenuOpen: handleMenuOpen,
    handleMenuClose: handleMenuClose,
    isNestedMenu: isNestedMenu,
    leftIcon: leftIcon,
    onClick: onClick,
    parentId: parentId,
    ref: ref,
    remove: remove,
    rightIcon: rightIcon,
    selected: selected,
    subNav: subNav,
    shortCutKey: shortCutKey,
    subNavAnchor: subNavAnchor,
    variant: variant
  }, restProps), children);
});
MenuItem.defaultProps = defaultProps;
MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   */
  changeMenuFocus: _propTypes["default"].func,
  /**
   * If `true`, the MenuItem will be styled as a label.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element, _propTypes["default"].string]),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/menu-item/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   */
  currentFocused: _propTypes["default"].number,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true`, the MenuItem will be styled as disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   * This allows the autofocus to be removed with a mouse enter
   */
  enableAutoFocus: _propTypes["default"].bool,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   */
  index: _propTypes["default"].number,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   */
  isNestedMenu: _propTypes["default"].bool,
  /**
   * Icon to be displayed on the left side of the MenuItem's children.
   */
  leftIcon: _propTypes["default"].node,
  /**
   * @ignore
   */
  onClick: _propTypes["default"].func,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   */
  parentId: _propTypes["default"].string,
  /**
   * If `true`, the MenuItem will be styled as a Delete/Remove action.
   */
  remove: _propTypes["default"].bool,
  /**
   * Icon to be displayed on the right side of the MenuItem's children.
   */
  rightIcon: _propTypes["default"].node,
  /**
   * If `true`, the MenuItem will be styled as selected.
   */
  selected: _propTypes["default"].bool,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   */
  setSubMenuState: _propTypes["default"].func,
  /**
   * Text to be displayed on the right side of the MenuItem's children.
   * Could also be used as a hint.
   */
  shortCutKey: _propTypes["default"].string,
  /**
   * Pass in additional MenuItems (wrapped with Fragements or an Array) to make a sub/nested navigation menu.
   * Menu nesting is limited to one level, additional subNav elements will not apply
   */
  subNav: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element]),
  /**
   * If `infoText`, the MenuItem will be styled as info text.
   * If `label`, the MenuItem will be styled as label.
   * If `standard`, the MenuItem will be styled as standard.
   */
  variant: _propTypes["default"].oneOf(['infoText', 'label', 'standard'])
} : {};
var _default = MenuItem;
exports["default"] = _default;